export const queryKeys = {
	me: ["me"] as const,
	enrollments: ["enrollments"] as const,
	courses: {
		all: ["courses"] as const,
		detail: (id: string) => ["courses", id] as const,
		content: (id: string) => ["courses", id, "content"] as const,
	},
	quiz: (moduleId: string) => ["quiz", moduleId] as const,
	admin: {
		dashboard: ["admin", "dashboard"] as const,
		students: ["admin", "students"] as const,
		student: (id: string) => ["admin", "students", id] as const,
		courses: ["admin", "courses"] as const,
		course: (id: string) => ["admin", "courses", id] as const,
		discounts: ["admin", "discounts"] as const,
		discount: (id: string) => ["admin", "discounts", id] as const,
	},
};
